"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC, Unbounded} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Divider, ScrollArea, SimpleGrid, UnstyledButton} from "@mantine/core";
import Group from "@/app/(index)/recruit/group";
import {loadRecruitPlans, loadRecruitVacancies} from "@/service";
import {IJobPlanDTO, IJobVacanciesDTO} from "@/form/jobs";
import ReadMore from "@/app/(index)/read-more";
import {useMediaQuery} from "@mantine/hooks";
import GroupSM from "@/app/(index)/recruit/group-sm";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const unbounded = Unbounded({
    weight: ['400','500', '600'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const groupRoom: {[key: string]: {[key: string]: string}} = {
    A: {title: "政策研究組", desc: "本組透過系統性的觀察與議題的深度解析，長期性地進行科技政策趨勢觀測與研析，並整合前瞻研究方法與科技創新能量評估工具，以建立中長期需求導向之科技發展策略，並協助我國擘劃科技發展方向。"},
    B: {title: "科研資料組", desc: "本組主要任務在建置完善之科技計畫審評管考作業所需平台及提供相關服務。同時建置科技人才、政策研究指標及科技發展觀測平台等資料庫，並利用大型資料庫內容進行以證據為基礎之加值分析，以協助政府之政策研究與規劃工作；此外，亦協助國內200餘個學研機構引進電子資訊資源及維運全國文獻傳遞與圖書互借服務體系，以支援學術研究。"},
    C: {title: "科產推動組", desc: "科產推動組主要任務為協助國科會實質規劃及推動新興科技相關方案。透過運用前瞻科技與產業創新議題之研究方法論，並鏈結內外部專家與跨智庫協作，研提新興科技與產業之策略建議，以滿足重大議題策略規劃及推動需求。目前本組主要核心團隊，包括智慧通訊、淨零科技、民生公共物聯網、科技人才。"},
    D: {title: "創新創業推動組", desc: "中心創新創業推動組，主要任務在了解科技預算支持下所產生的知識與技術，並協助將這些知識與技術有策略的商品化，維運並讓生態系健全發展。因此，配合政府重點產業發展政策，持續規劃辦理「創新創業激勵」、「科研創業」等新創相關政策計畫，並協助落實創新成果產業化之激勵政策，以及加強與美國矽谷等各國創新區域之合作關係，持續精進創新創業團隊與國內外資源的鏈結，進而打造出健全的創業生態體系。"},
    E: {title: "資訊系統組", desc: "主要負責本中心各團隊對內、對外執行科技政策研究與資訊服務相關業務所需使用之科研數據資料、資訊系統、指標統計分析、數據資料運算工具、創新創業與產學鏈結及服務平台等之開發建置、規劃推動、維運管理與功能擴充，暨資通信基礎設施、資訊安全管理之總合計畫團隊。"},
    F: {title: "行動服務組", desc: ""},
    G: {title: "企劃推廣組", desc: ""},
    H: {title: "財會小組", desc: ""},
    I: {title: "教育部專案辦公室", desc: ""},
    J: {title: "主任室", desc: ""},
}

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const [tab, setTab] = useState<string>("A");
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }
    const [dataCount, setDataCount] = useState<{[key: string]: number}>({});
    const [planCount, setPlanCount] = useState<{[key: string]: number}>({});
    const [planData, setPlanData] = useState<{[key: string]: IJobPlanDTO[]}>({});
    const [vacanciesData, setVacanciesData] = useState<{[key: string]: IJobVacanciesDTO[]}>({});
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    useEffect(() => {

        Promise.all([loadRecruitPlans(), loadRecruitVacancies()])
            .then(([pData, vData]) => {
                let dataCountTemp: {[key: string]: number} = {};
                let planCountTemp: {[key: string]: number} = {};

                console.log(vData);
                Object.keys(pData).forEach(key => {
                    let count = 0;
                    pData[key].forEach(plan => {
                        let pCount = 0;
                        if(vData[plan.jpnId] !== undefined){
                            vData[plan.jpnId].forEach(vacancies => {
                                count += vacancies.numberOfVacancies??0;
                                pCount += vacancies.numberOfVacancies??0;
                            });
                            planCountTemp[plan.jpnId] = pCount;
                        }
                    });
                    dataCountTemp[key] = count;
                });
                setDataCount(dataCountTemp);
                setPlanCount(planCountTemp);
                setPlanData(pData);
                setVacanciesData(vData);
            })
    }, []);

    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name="人才招募"/>
                    )
                }
                <div
                    className={cx("mx-auto", mediaQueryLessSM ? 'w-[1250px]' : 'w-full my-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        人才招募
                    </div>
                    <div className="mt-[40px] text-[20px] leading-[40px]">
                        國家實驗研究院科技政策研究與資訊中心（STPI）成立於1974年，長期以來專責於我國科技研究發展所需資料之蒐集、建置、分析、處理與服務等事務。近年來在既有之資訊資源基礎上，強化趨勢研析、關鍵議題發掘、專利情報分析、創新創業推動等能量，並協助政府擘劃我國科技發展之願景與策略，以朝向專業之科技政策研究智庫邁進。
                    </div>
                    <Divider my={35} color={"#cedbdc"}/>
                    <div className="text-[30px] font-bold">熱門職缺</div>

                    {
                        mediaQueryLessSM && (
                            <ScrollArea w={1250}>
                                <div className="mt-[50px] flex justify-center items-start gap-[50px]">
                                    {
                                        Object.keys(planData).map(key => (
                                            <UnstyledButton onClick={() => setTab(key)}>
                                                <Group name={groupRoom[key]["title"]} iconIndex={key} active={tab === key}
                                                       total={dataCount[key]}/>
                                            </UnstyledButton>
                                        ))
                                    }
                                </div>
                            </ScrollArea>
                        )
                    }

                    {
                        !mediaQueryLessSM && (
                            <div className="mt-[50px] px-[10px]">
                                <SimpleGrid cols={2} >
                                    {
                                        Object.keys(planData).map(key => (
                                            <UnstyledButton onClick={() => setTab(key)}>
                                                <GroupSM name={groupRoom[key]["title"]} iconIndex={key} active={tab === key}
                                                         total={dataCount[key]}/>
                                            </UnstyledButton>
                                        ))
                                    }
                                </SimpleGrid>

                            </div>
                        )
                    }
                </div>
                <div className="bg-[#f1f7f5]">
                    <div className={cx("mx-auto border-t-[4px] border-[#458481]", mediaQueryLessSM ? "w-[1250px] px-[60px] py-[45px]" : "w-full px-[20px] py-[20px]")}>

                        <div className={cx("flex", mediaQueryLessSM ? "gap-[15px]" : "flex-col gap-[5px]")}>
                            <div className={cx("text-[#458481] font-bold ", mediaQueryLessSM ? "min-w-[80px] leading-[42px] text-[36px]" : "text-[24px]")}>
                                本組介紹
                            </div>
                            {
                                !mediaQueryLessSM && (
                                    <Divider color={"#999"} orientation="vertical" className={"relative top-1"}/>
                                )
                            }
                            <div
                                className={cx("text-black text-[20px]", mediaQueryLessSM ? "" : "text-justify")}>
                                {groupRoom[tab]["desc"]}
                            </div>
                        </div>
                        {
                            Object.keys(planData).map(key => (
                                <div key={`group-room-${key}`} className={cx(tab === key ? "block" : "hidden")}>
                                    {
                                        planData[key].map((item, index) => (
                                            <>
                                                <div className="flex border-t border-[#208a93] mb-[30px] mt-[35px]">
                                                    <div className="h-[44px] bg-[#208a93] flex px-[15px] items-center">
                                                        {
                                                            mediaQueryLessSM && (
                                                                <div className="text-[#cfc49a] font-bold">計畫名稱．</div>)
                                                        }
                                                        <div className="text-white font-bold">{item.title} ( {planCount[item.jpnId]} )</div>
                                                    </div>
                                                    <div
                                                        className="border-r-[11px] border-r-transparent border-b-[22px] border-b-transparent border-t-[22px] border-t-[#208a93] border-l-[11px] border-l-[#208a93]"></div>
                                                </div>
                                                {
                                                    (vacanciesData[item.jpnId] !== undefined) && (
                                                        vacanciesData[item.jpnId].map(item2 => (
                                                            <>
                                                                <div>
                                                                    <div
                                                                        className="text-[#458481] text-[15px] font-bold">目前職缺》
                                                                    </div>
                                                                    <div
                                                                        className="text-[#8d7f4c] text-[30px] font-bold">{item2.title}({item2.numberOfVacancies})
                                                                    </div>

                                                                    <div
                                                                        className="mt-[20px] text-[17px] border-l border-[#8d7f4c] pl-[20px]">
                                                                        <div className="text-[#999]">工作內容說明：</div>
                                                                        <div className="text-black">{item2.info}</div>
                                                                    </div>

                                                                    <div className="mt-[25px]">
                                                                        <ReadMore name="前往應徵" url={item2.linkUrl!!}/>
                                                                    </div>
                                                                </div>
                                                                <Divider color={"#ccc"} my={30}/>
                                                            </>
                                                        ))
                                                    )
                                                }
                                            </>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}
